import { Result, err, ok } from 'neverthrow';
import { KeywordRepository } from '../Repositories/KeywordRepository';
import {
  KeywordOptimizationRequest,
  KeywordOptimizationResponse,
  KeywordOptimizationError
} from '../../Model/KeywordOptimization';

export class KeywordOptimizationUseCase {
  constructor(private repo: KeywordRepository) {}

  async execute(request: KeywordOptimizationRequest): Promise<Result<KeywordOptimizationResponse, KeywordOptimizationError>> {
    try {
      // Validation
      const validationResult = this.validateRequest(request);
      if (validationResult.isErr()) {
        return err(validationResult.error);
      }

      // Validate mid format (should be numeric)
      const midValidationResult = this.validateMid(request.mid);
      if (midValidationResult.isErr()) {
        return err(midValidationResult.error);
      }

      // Call repository
      const response = await this.repo.optimizeKeywords(request);
      return ok(response);

    } catch (error) {
      return err({
        type: 'API_ERROR',
        message: '키워드별 순위 조회 중 오류가 발생했습니다.',
        details: error instanceof Error ? error.message : String(error)
      });
    }
  }

  private validateRequest(request: KeywordOptimizationRequest): Result<void, KeywordOptimizationError> {
    if (!request.product_url || !request.product_name || !request.main_keyword || !request.mid) {
      return err({
        type: 'VALIDATION_ERROR',
        message: '모든 필수 파라미터를 입력해주세요.',
        details: 'product_url, product_name, main_keyword, mid는 필수입니다.'
      });
    }

    if (request.product_url.trim() === '' || request.product_name.trim() === '' ||
        request.main_keyword.trim() === '' || request.mid.trim() === '') {
      return err({
        type: 'VALIDATION_ERROR',
        message: '빈 값은 입력할 수 없습니다.',
        details: '모든 필드는 비어있지 않아야 합니다.'
      });
    }

    return ok(undefined);
  }

  private validateMid(mid: string): Result<void, KeywordOptimizationError> {
    // Check if mid contains only numbers
    if (!/^\d+$/.test(mid)) {
      return err({
        type: 'VALIDATION_ERROR',
        message: 'MID는 숫자만 입력 가능합니다.',
        details: `입력된 MID: ${mid}`
      });
    }

    return ok(undefined);
  }
}
